import { $isLinkNode } from '@lexical/link';
import type { LexicalNode, RangeSelection } from 'lexical';

/**
 * Verifica si todos los nodos en la selección comparten el mismo objetivo de enlace.
 * Si es así, devuelve el objetivo del enlace, de lo contrario devuelve undefined.
 */
export function $getSharedLinkTarget(selection: RangeSelection | null): string | undefined {
  if (!selection) return undefined;

  const nodes = selection.getNodes();
  if (nodes.length === 0) return undefined;

  let sharedLinkTarget: string | undefined;

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    const parent = node.getParent();

    if (!$isLinkNode(parent)) {
      return undefined;
    }

    const linkTarget = parent.getURL();

    if (i === 0) {
      sharedLinkTarget = linkTarget;
    } else if (linkTarget !== sharedLinkTarget) {
      return undefined;
    }
  }

  return sharedLinkTarget;
}
